import React from "react";

type FormControlProps = {
  children: React.ReactNode;
};

const FormControl: React.FC<FormControlProps> = ({ children }) => {
  return <div className="editing-form-control-nested-control mb-4 last:mb-0">{children}</div>;
};

export default FormControl;
